const apiError = (apiError = null, action) => {
  switch (action.type) {
    case 'API_ERROR':
      return action.payload
    default:
      return apiError
  }
}
export default apiError
